<script setup>
import { useBlockSafe } from '@/composables/useBlockSafe';
import Gallery from '@/components/ui/Gallery.vue';
import RedSpot from '@/components/RedSpot.vue';
const props = defineProps({
  data: {
    type: Object,
    default: () => ({}),
  },
});
const {
  id,
  backgroundColor,
  spacingTop,
  spacingBottom,
  title,
  redSpot,
  items,
  hasTitle,
  hasRedSpot,
  hasItems,
  hasAnyContent,
  template,
} = useBlockSafe(props.data);
</script>
<template>
  <section
    v-if="hasAnyContent"
    :id="id"
    class="section"
    :class="[
      backgroundColor && template !== 'article' ? `bg-${backgroundColor}` : '',
      spacingTop ? `section--top-${spacingTop}` : 'section--top-xl',
      spacingBottom ? `section--bottom-${spacingBottom}` : 'section--bottom-xl',
    ]"
    data-aos="fade-up"
    data-aos-easing="ease-out-cubic"
  >
    <RedSpot
      v-if="hasRedSpot"
      :position-vertical="redSpot.vertical"
      :position-horizontal="redSpot.horizontal"
    />
    <div :class="['container', `container--${template}`]">
      <div class="gallery-block">
        <h2
          v-if="hasTitle"
          class="mb-0 gallery-block__title h2"
          :class="[
            backgroundColor === 'black' && template !== 'article'
              ? 'white'
              : 'black',
          ]"
          data-aos="fade-up"
          data-aos-easing="ease-out-cubic"
          v-html="title"
        ></h2>
        <Gallery
          v-if="hasItems"
          :id="`gallery-${id}`"
          :items="items"
          :background-color="template === 'article' ? 'white' : backgroundColor"
          :view="template === 'default' ? 'without-fraction' : ''"
        />
      </div>
    </div>
  </section>
</template>

<style scoped lang="scss">
.gallery-block {
  display: flex;
  flex-direction: column;
  gap: 56px;
  @include media-breakpoint-up(sm) {
    gap: 80px;
  }
  @include media-breakpoint-up(xl) {
    @include responsive-spacing(gap, 80);
  }
  &__title {
    margin: 0 auto;
    text-align: center;
  }
}
</style>
